import styled from 'styled-components';
import { ReactComponent as noNotificationIcon } from '../../../../../assets/bell-empty.svg';
import { StyledSeparator } from '../Section/Notification/Notification.styles';

export const StyledNotificationIcon = styled(noNotificationIcon)`
  display: block;
  height: 70px;
  width: 61px;
  margin: auto;
  color: ${({ theme }) => theme.colors.blue6};
  margin-bottom: 24px;
`;

export const StyledContentWrapper = styled.div`
  margin : 0 -16px -36px -16px;
`;

export const StyledSeparatorNoResult = styled(StyledSeparator)`
  margin-bottom: 36px;
`;
